export const provinciaOrigine = ["Sondrio", "Milano", "Brescia", "Torino"];

export const naturaTransazione = [
  { id: 1, value: "Acquisto o vendita - A" },
  { id: 2, value: "Restituzione o sostituzione - B" },
  { id: 3, value: "Aiuti governativi privati o finanziati dalla Comunità Europea - C" },
  { id: 4, value: "Operazione in vista di una lavorazione per conto terzi - D" },
  { id: 5, value: "Operazione successiva ad una lavorazione per conto terzi - E" },
  { id: 6, value: "Movimento di merci senza trasferimento di proprietà - F" },
  { id: 7, value: "Operazione a titolo di un programma comune di difesa - G" },
  { id: 8, value: "Fornitura di materiali e macchinari nel quadro di un contratto generale di costruzione - H" },
  { id: 9, value: "Altre trasazioni - I" }
];

export const deliveryTerms = [
  { id: "a", value: "E - Franco fabbrica" },
  { id: "b", value: "F - Franco vettore/lungo bordo/a bordo" },
  { id: "c", value: "C - Costo e nolo/costo,assicurazione,nolo,etc/Trasporto pagato fino a/Trasporto e assicurazione pagati fino a" },
  { id: "d", value: "D - Reso frontiera/ex ship/banchina/non sdoganato/sdoganato(non va usato negli elenchi intra)" }
];

export const deliveryMode = [
  { id: 1, value: "1 - Trasporto marittimo" },
  { id: 2, value: "2 - Trasporto ferroviario" },
  { id: 3, value: "3 - Trasporto stradale" },
  { id: 4, value: "4 - Trasporto aereo" },
  { id: 5, value: "5 - Spedizioni postali" },
  { id: 7, value: "7 - Installazioni fisse di trasporto" },
  { id: 8, value: "8 - Trasporto via acqua" },
  { id: 9, value: "9 - Propulsione propria" }
];

export const destinationCountry = ["Sondrio", "Milano", "Brescia", "Torino"];

export const stato = ["Italia", "Inghilterra", "Francia", "Germania"];

// export const deliveryMode = [{ id: 1, value: "Modalità 1" }, { id: 2, value: "Modalità 2" }, { id: 3, value: "Modalità 3" }];

export const collectionMode = [{ id: 1, value: "Incasso 1" }, { id: 2, value: "Incasso 2" }, { id: 3, value: "Incasso 3" }];

export const referenceFrequency = [{ id: "monthly", description: "Mensile" }, { id: "quarterly", description: "Trimestrale" }];

export const referencePeriod = [
  { id: "jan", description: "Gennaio" },
  { id: "feb", description: "Febbraio" },
  { id: "mar", description: "Marzo" },
  { id: "apr", description: "Aprile" },
  { id: "may", description: "Maggio" },
  { id: "jun", description: "Giugno" },
  { id: "jul", description: "Luglio" },
  { id: "aug", description: "Agosto" },
  { id: "sep", description: "Settembre" },
  { id: "oct", description: "Ottobre" },
  { id: "nov", description: "Novembre" },
  { id: "dec", description: "Dicembre" },
  { id: "first", description: "1° trimestre" },
  { id: "second", description: "2° trimestre" },
  { id: "third", description: "3° trimestre" },
  { id: "fourth", description: "4° trimestre" }
];
